module.exports = __webpack_public_path__ + "img/Shayna_Ventricelli.5e09623a.jpg";